// Formats the server's `day_summary` block from the route payload into the
// header one-liner for MyWork's mobile route view.
//
// Server shape (per MOBILE_LOCATION_SERVER_SPEC.md):
//   day_summary: { total_miles, total_drive_minutes, stops_remaining }
// Plus stop count derivable from the surrounding route response.

const formatMiles = (miles) => {
  if (miles == null) return '— mi';
  return Number(miles).toFixed(miles < 10 ? 1 : 0) + ' mi';
};

const formatDuration = (totalMinutes) => {
  if (totalMinutes == null) return '—';
  const mins = Math.round(totalMinutes);
  if (mins < 60) return `${mins} min`;
  const hours = Math.floor(mins / 60);
  const remainder = mins % 60;
  return remainder === 0 ? `${hours}h` : `${hours}h ${remainder}m`;
};

/**
 * @param {Object} daySummary - { total_miles, total_drive_minutes, stops_remaining }
 * @param {number} stopCount - total stop count for the day (from route.stops.length)
 * @returns {string} e.g. "4 stops · 38 mi · est 5h 20m"
 */
export const formatHeader = (daySummary, stopCount) => {
  if (!daySummary && !stopCount) return '';
  const parts = [];
  if (stopCount != null) parts.push(`${stopCount} stop${stopCount === 1 ? '' : 's'}`);
  if (daySummary?.total_miles != null) parts.push(formatMiles(daySummary.total_miles));
  if (daySummary?.total_drive_minutes != null) {
    parts.push(`est ${formatDuration(daySummary.total_drive_minutes)} driving`);
  }
  return parts.join(' · ');
};

const DayStatSummary = { formatHeader, formatMiles, formatDuration };
export default DayStatSummary;
